import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

const app = createApp(App)


import 'bootstrap/dist/css/bootstrap.rtl.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import './assets/css/app.css'
import 'animate.css'

import AOS from "aos";
import "aos/dist/aos.css";
app.AOS = new AOS.init();


import resources from './resources'
import models from './models'
import plugins from './plugins'
import server from './server'




app.config.globalProperties.$res = resources
app.config.globalProperties.$models = models
app.config.globalProperties.$plugins = plugins
app.config.globalProperties.$server = server


app.use(store)
app.use(router)
app.mount('#app')